import { connect } from "react-redux";
import * as fromActions from "../../actions";
import Form from "./form";
import { onSiteInspectionChecklistListRequest } from "features/health-and-safety";

const mapStateToProps = ({ addSiteInspectionChecklistFormReducer }) => ({
	values: addSiteInspectionChecklistFormReducer,
});

const mapDispatchToProps = {
	onChange: fromActions.onAddSiteInspectionChecklistValueChange,
	onReset: fromActions.onAddSiteInspectionChecklistReset,
	onSave: fromActions.onAddSiteInspectionChecklistSave,
	onGetSiteInspectionChecklistList: onSiteInspectionChecklistListRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form); 